var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4749 4.8067C12.413 4.74421 12.3392 4.69461 12.258 4.66077C12.1767 4.62692 12.0896 4.6095 12.0016 4.6095C11.9136 4.6095 11.8264 4.62692 11.7452 4.66077C11.664 4.69461 11.5902 4.74421 11.5283 4.8067L6.56159 9.78003L4.47493 7.6867C4.41058 7.62454 4.33462 7.57566 4.25138 7.54286C4.16815 7.51006 4.07926 7.49397 3.98981 7.49552C3.90036 7.49706 3.81208 7.51622 3.73003 7.55188C3.64798 7.58754 3.57375 7.63902 3.51159 7.70336C3.44944 7.76771 3.40056 7.84367 3.36776 7.92691C3.33495 8.01014 3.31887 8.09903 3.32041 8.18848C3.32196 8.27793 3.34111 8.36621 3.37678 8.44826C3.41244 8.53031 3.46391 8.60454 3.52826 8.6667L6.08826 11.2267C6.15024 11.2892 6.22397 11.3388 6.30521 11.3726C6.38645 11.4065 6.47359 11.4239 6.56159 11.4239C6.6496 11.4239 6.73674 11.4065 6.81798 11.3726C6.89922 11.3388 6.97295 11.2892 7.03493 11.2267L12.4749 5.7867C12.5426 5.72427 12.5966 5.6485 12.6335 5.56417C12.6705 5.47983 12.6895 5.38876 12.6895 5.2967C12.6895 5.20463 12.6705 5.11356 12.6335 5.02923C12.5966 4.94489 12.5426 4.86912 12.4749 4.8067Z",
    fill: "#250044"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.25e6b6e4e2fbee3fbd206cf2502f8926.svg";
export { ForwardRef as ReactComponent };